import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  cardPolicyInfo: {
    paddingTop: token.paddingXS,
    paddingBottom: token.paddingXS
  },
  descriptionItemSecondary: {
    padding: 0 + '!important'
  },
  descriptionItemPrimary: {
    paddingBottom: token.paddingXS + 'px!important'
  },
  dateCell: {
    color: 'inherit',
    fontWeight: 'inherit'
  }
}))
